import React, { useState } from "react"
import { Link,graphql } from "gatsby"

import Layout from "../components/layout"
import BreadCrumb from "../components/breadcrumb"
import Img from "gatsby-image"
import WdModal from '../components/modal'
import ModalPost from '../components/modalpost'
import Success from '../components/success'
import { GTMPhoneClick } from "../lib/gtag"

const Service = ({pageContext,path,data}) => {
  var metainfo = {
    title: pageContext.metainfo? (pageContext.metainfo.title || 'Επικοινωνία') + " | " + process.env.SITE_NAME  : (pageContext.title || 'Επικοινωνία') + " | " + process.env.SITE_NAME,
    description:pageContext.metainfo? pageContext.metainfo.description || '' : '',
    image:'/images/logo.png'
  }

  const [reveal, setReveal] = useState(false)
  const [revealsuccess,setRevealSuccess] = useState(false)

  return (
    <Layout metainfo={metainfo}>

      <WdModal setRevealSuccess={setRevealSuccess} setReveal={setReveal} reveal={reveal}/>
      <ModalPost reveal={revealsuccess} setReveal={setRevealSuccess}>
        <Success/>
      </ModalPost>

      <BreadCrumb title={pageContext.title}/>

      <div className="service-details-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-7">

              <div className="single-service">
                <h2>Ενοικίαση Καλαθοφόρου</h2>
                <p>Η εταιρεία μας αναλαμβάνει με συνέπεια και επαγγελματισμό κάθε εργασία που απαιτεί ανύψωση με καλαθοφόρο μηχάνημα. 
                Διαθέτουμε σύγχρονο, ασφαλές και πιστοποιημένο εξοπλισμό, ιδανικό για κάθε είδους εργασίες σε ύψος. 
                Το εξειδικευμένο προσωπικό μας διασφαλίζει την ασφαλή και ομαλή εκτέλεση της εργασίας.</p>

              <h3>Το καλαθοφόρο μας είναι κατάλληλο για:</h3>
              <ul>
                <li>Ανυψώσεις και μεταφορές αντικειμένων</li>
                <li>Πρόσβαση σε προσόψεις κτηρίων για τεχνικές εργασίες όπως βαψίματα,κλαδέματα</li>
                <li>Εργασίες εγκατάστασης ή συντήρησης σε ύψος</li>
              </ul>


              </div>

            </div>

            <div className="col-md-5">
              <div className="row">

                { data.kalathoforo.edges.map((item) => {
                  return (
                    <div className="col-12 my-2">
                      <div className="single-service-bg">
                        <Img fluid={item.node.childImageSharp.fluid}
                             alt={`metakomisi`}
                        />
                      </div>
                    </div>

                  )
                })}

              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="quotation-block mt-4">
                <div className="quotation-text py-4 text-center">
                  <h4>Κόστος Ενοικίασης Καλαθοφόρου</h4>
                  <p>Ζητήστε μια προσφορά για τις  υπηρεσίες ενοικίασης καλαθοφόρου που μπορούμε να σας παρέχουμε.</p>
                  <div className="request-button">
                    <button onClick={()=>setReveal(true)} type="button" className="btn btn-request">ΜΑΘΕ ΤΟ ΚΟΣΤΟΣ<i className="las la-arrow-right" /></button>
                  </div>
                </div>
                <div className="quotation-dtl text-white">
                  <p><i className="las la-mobile" />Μπορείτε να μας βρείτε στα τηλέφωνα: <a onClick={()=> GTMPhoneClick()} href="tel:6949873177">694 987 3177</a>, <a onClick={()=> GTMPhoneClick()} href="tel:6942073329">694 207 3329</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </Layout>
  )
}

export default Service


export const query = graphql`
  query {



   kalathoforo:allFile(filter: {name: {in: ["kalathoforo"]}}) {
   edges {
     node {
       childImageSharp {
         fluid(maxWidth: 500,quality:80) {
           ...GatsbyImageSharpFluid
         }
       }
     }
   }
 }


  }
`
